import NavMenu from './NavMenu';
import Toolbar from '@mui/material/Toolbar';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            backgroundColor: '#f0f0f0'
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(2),
            width: 'calc(100% - 240px)',
            backgroundColor: '#ffffff'
        },
    }),
);

interface IProps {
    children: any;
}

const Layout = (props: IProps) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
                <NavMenu />
            <main className={classes.content}>
                <Toolbar />
                    {props.children}
            </main>
        </div>
    );
}
export default Layout;